import { Component } from '@angular/core';
import { ReportManagementService } from '../../services/report-management.service';

@Component ({
    selector: 'app-report',
    template: '<router-outlet></router-outlet>'
})

export class ReportViewComponent {
}



// WEBPACK FOOTER //
// ./src/app/report/components/view/report-view.component.ts